

import moment from 'moment-timezone'

const getMomentDateObj = (dateString, timezone = 'Europe/Berlin') => moment.tz(dateString, timezone)

export default getMomentDateObj